import Model from 'flarum/common/Model';
export default class Pick extends Model {
  userId = Model.attribute('userId');
  eventId = Model.attribute('eventId');
  selectedOutcome = Model.attribute('selectedOutcome');
  isCorrect = Model.attribute('isCorrect');
  event = Model.hasOne('event');
  user = Model.hasOne('user');
}
flarum.reg.add('huseyinfiliz-pickem', 'common/models/Pick', Pick);